import React from 'react';
import '../less';
import title_img from '../img/title_img.png';
import Banner from "../../../../auxiliary-components/shared/Banner";
import { Link } from "MWComponents";

export default function template() {
  const isMobile = this.isViewportMobile(),
    widgetData = this.state.widgets.find(widget => widget.code === 'shares') ? this.state.widgets.find(widget => widget.code === 'shares').data : [],
    sortedWidget = this.filterSlidesByEnvironment(widgetData),
  offers = sortedWidget.sort((a, b) => b.order - a.order).map((item) => {
    const bgImage = isMobile ? this.changeFilesUrl(item.image_mobile) : this.changeFilesUrl(item.image_desktop);
    return (
      <div className='offer-item'>
        <Banner
          bg={bgImage}
          text={item.desc_desktop}
          textMob={item.desc_mobile}
          title={item.text_above}
          page={'stepToVictory'}
          dates={item.text_lower}
          offerMode={true}
          link={item.banner_file_link
            ? item.banner_file_link
            : item.banner_file_path
              ? this.changeFilesUrl(item.banner_file_path)
              : '/'}
          isMobile={isMobile}
          titleTag={"h2"}
        />
        {
          item.files && item.files.length ?
            <div className="downloads">
              <div className={`documents-component`}>
                <div className={`content`}>
                  <div className="documents-component-title">
                    {this.l10n('OFFERLIST_LIST_TITLE')}
                  </div>
                  {item.files.sort((a, b) => b.order - a.order).map((file, index) => {
                      const filePath = this.changeDownloadsUrl(file.path);
                      const fileLink = file.link;
                      const text = file.title;
                      return (<div key={index} className="documents-component-item">
                        <Link href={filePath ? filePath : fileLink} target="_blank">
                          <img src={this.changeDownloadsUrl(file.image)} alt='doc-img'></img>
                          <div dangerouslySetInnerHTML={{__html: text}}></div>
                        </Link>
                      </div>)
                    }
                  )}
                </div>
              </div>
            </div>
            : ''
        }

      </div>
    )
  });

    return (
        <div className='module-special-offers'>
          <div className='content'>
            <div className='title-block'>
              <div className='title-block-left'>
                <h1 className='title-block-title'>{this.l10n('HEADER_LINK_SHARE')}</h1>
                <div className='title-block-text' dangerouslySetInnerHTML={{__html: this.l10n('SPECIAL_OFFERS_TITLE_TEXT')}}></div>
              </div>
              <img className='title-block-img' src={title_img} alt="title_img" />
            </div>
          </div>
          {offers}
        </div>
    );
}
